// BillingDataForm helper functions and data
import { validationRules } from "@sushicorp/utils";
import { DocumentType } from "artisn/types";
import * as yup from "yup";

const { requiredEmail, requiredPhoneNumber } = validationRules;
const { documentRules, requiredDocumentType } = validationRules;
const { requiredBillingAddress, twoOrMoreWords } = validationRules;

export const getBillingDataFormSchema = (
  documentType: DocumentType | undefined
) => {
  return yup.object().shape({
    documentType: requiredDocumentType,
    name: twoOrMoreWords("El campo debe contener mínimo dos palabras"),
    lastname: yup.string().optional().nullable(),
    document: documentRules(documentType),
    email: requiredEmail,
    phone: requiredPhoneNumber,
    address: requiredBillingAddress,
    externalId: yup.string().optional().nullable()
  });
};
